import { Component, OnInit } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import createAutoCorrectedDatePipe from 'text-mask-addons/dist/createAutoCorrectedDatePipe';

@Component({
  selector: 'app-registermeeting',
  templateUrl: './registermeeting.component.html',
  styleUrls: ['./registermeeting.component.css']
})
export class RegistermeetingComponent implements OnInit {
   // maxYear ska sättas dynamiskt.
   minmaxyear = { minYear: '1920', maxYear: '2030' };
   autoCorrectedDatePipe = createAutoCorrectedDatePipe('yyyy-mm-dd', this.minmaxyear);
   public maskdatum = [/[129]/, /[?09]/, /\d/, /\d/, '-', /\d/, /\d/, '-', /\d/, /\d/];
 registermeetingform;
  

  constructor(private fb: FormBuilder) { }

  ngOnInit(): void {
    this.registermeetingform = this.fb.group({
      meetingDate: ['', ''],
      issue: ['', ''],
      comment: ['', ''],
      meetingTypeId: ['', '']
    });
  }
  
  onSubmit() {

  }

  save() {

  }
}
